import { useActionData } from 'react-router';

import { getBrowser } from '~/utils/browser';

import ContactForm from './ContactForm';

export const meta = () => {
  return [{ title: 'Contact' }];
};

type ActionData = {
  errors?: string[];
  success: boolean;
};

type FormDataValues = {
  email: string;
  message: string;
  name: string;
  orderNumber?: string;
  subject: string;
};

function getZendeskRequestBody(formFields: FormDataValues, request: Request) {
  const { name, email, message, orderNumber, subject } = formFields;

  const clientBrowser = getBrowser(request.headers.get('user-agent'));

  return {
    request: {
      comment: {
        body: `${message}
      ${orderNumber && `\nOrder number: ${orderNumber}`}
      \n
      Browser: ${clientBrowser}`
      },
      custom_fields: [
        { id: 360014500158, name: 'Platform', value: 'Web' },
        { id: 360014587577, name: 'Department', value: 'TSS' }
      ],
      requester: { email, name: `${name} - ${email}` },
      subject
    }
  };
}

function isFormDataValid(formData: FormDataValues) {
  const errors: string[] = [];

  if (!formData.name) errors.push('name');
  if (!formData.email) errors.push('email');
  if (!formData.subject) errors.push('subject');
  if (!formData.message) errors.push('message');

  return errors.length > 0 ? errors : null;
}

function parseFormData(formData: FormData): FormDataValues {
  return {
    email: formData.get('email') as string,
    message: formData.get('message') as string,
    name: formData.get('name') as string,
    orderNumber: formData.get('order_number') as string,
    subject: formData.get('subject') as string
  };
}

export const action = async ({ request }: { request: Request }) => {
  const formData = await request.formData();
  const parsedFormData = parseFormData(formData);
  const errors = isFormDataValid(parsedFormData);

  if (errors) return { errors, success: false };

  return fetch('https://thesolesupplier.zendesk.com/api/v2/requests.json', {
    body: JSON.stringify(getZendeskRequestBody(parsedFormData, request)),
    headers: { 'content-type': 'application/json' },
    method: 'POST'
  })
    .then(() => ({ success: true }))
    .catch(() => ({ success: false }));
};

export default function Contact() {
  const actionData = useActionData<ActionData>();

  return (
    <section className="content-width flex min-h-[60vh] flex-col justify-between gap-6 py-12 md:my-auto md:flex-row md:gap-12">
      <div className="flex max-w-[400px] flex-col gap-4">
        <h1 className="text-title-xl font-medium">Contact</h1>

        <p className="flex flex-col gap-1 text-grey-read">
          <span>The Sole Supplier</span>
          <span>3rd Floor</span>
          <span>86-90 Paul Street</span>
          <span>London EC2A 4NE</span>
        </p>

        <p className="flex flex-col gap-1 text-grey-read">
          <span>
            For advertising enquiries or to request a media kit please contact:
          </span>
          <a
            href="mailto:christian@thesolesupplier.co.uk"
            className="text-black underline"
          >
            christian@thesolesupplier.co.uk
          </a>
        </p>
      </div>

      <div className="w-full md:w-[500px]">
        <ContactForm
          errors={actionData?.errors}
          success={actionData?.success}
        />
      </div>
    </section>
  );
}
